// extracted by mini-css-extract-plugin
export default {"selfIntro":"styles_selfIntro__BJmYV","profilePicContainer":"styles_profilePicContainer__xgl9s"};